export enum EReduxState {
    initialState = 'initialState',
    pending = 'pending',
    fulfilled = 'fulfilled',
    rejected = 'rejected',
}

